//
// StyleElement.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var StyleElement = {
    GRAPH_DEFAULTS:0,
    GRAPH_DATA_1:1,
    GRAPH_DATA_2:2,
    GRAPH_DATA_3:3,
    GRAPH_DATA_4:4,
    GRAPH_DATA_5:5,
    GRAPH_DATA_6:6,
    GRAPH_DATA_7:7,
    GRAPH_DATA_8:8,
    GRAPH_DATA_9:9,
    GRAPH_DATA_10:10,
    GRAPH_DATA_11:11,
    GRAPH_DATA_12:12,
    GRAPH_DATA_DEFAULT:13,
    GRAPH_DATA_NODE_1:14,
    GRAPH_DATA_NODE_2:15,
    GRAPH_DATA_NODE_3:16,
    GRAPH_DATA_NODE_4:17,
    GRAPH_DATA_NODE_5:18,
    GRAPH_DATA_NODE_6:19,
    GRAPH_DATA_NODE_7:20,
    GRAPH_DATA_NODE_8:21,
    GRAPH_DATA_NODE_9:22,
    GRAPH_DATA_NODE_10:23,
    GRAPH_DATA_NODE_11:24,
    GRAPH_DATA_NODE_12:25,
    GRAPH_DATA_NODE_DEFAULT:26,
    GRAPH_DATA_NODE_TARGET:27,
    GRAPH_KPI_RANGE_1:28,
    GRAPH_KPI_RANGE_2:29,
    GRAPH_KPI_RANGE_3:30,
    GRAPH_KPI_RANGE_4:31,
    GRAPH_KPI_RANGE_5:32,
    GRAPH_KPI_RANGE_DEFAULT:33,
    GRAPH_KPI_OVERFLOW:34,
    GRAPH_KPI_UNDERFLOW:35,
    GRAPH_OUTLIER:36,
    THREE_COLOR_RAMP:37,
    THREE_COLOR_RAMP_1:38,
    THREE_COLOR_RAMP_2:39,
    THREE_COLOR_RAMP_3:40,
    THREE_COLOR_RAMP_4:41,
    THREE_COLOR_RAMP_KPI:42,
    THREE_COLOR_ALT_RAMP:43,
    THREE_COLOR_ALT_RAMP_1:44,
    THREE_COLOR_ALT_RAMP_2:45,
    THREE_COLOR_ALT_RAMP_3:46,
    THREE_COLOR_ALT_RAMP_4:47,
    THREE_COLOR_ALT_RAMP_KPI:48,
    TWO_COLOR_RAMP:49,
    TWO_COLOR_RAMP_1:50,
    TWO_COLOR_RAMP_2:51,
    TWO_COLOR_RAMP_3:52,
    TWO_COLOR_RAMP_4:53,
    TWO_COLOR_RAMP_5:54,
    TWO_COLOR_RAMP_6:55,
    TWO_COLOR_RAMP_7:56,
    TWO_COLOR_RAMP_8:57,
    TWO_COLOR_RAMP_OTHER:58,
    TWO_COLOR_ALT_RAMP:59,
    TWO_COLOR_ALT_RAMP_1:60,
    TWO_COLOR_ALT_RAMP_2:61,
    TWO_COLOR_ALT_RAMP_3:62,
    TWO_COLOR_ALT_RAMP_4:63,
    TWO_COLOR_ALT_RAMP_5:64,
    TWO_COLOR_ALT_RAMP_6:65,
    TWO_COLOR_ALT_RAMP_7:66,
    TWO_COLOR_ALT_RAMP_8:67,
    TWO_COLOR_ALT_RAMP_OTHER:68,
    ICON_NODE_BACKGROUND:69,
    ICON_NODE_END:70,
    ICON_NODE_GATEWAY_EXCLUSIVE:71,
    ICON_NODE_GATEWAY_INCLUSIVE:72,
    ICON_NODE_START:73,
    ICON_NODE_TIMER:74,
    GRAPH_AXIS_LINES:75,
    GRAPH_REFERENCE:76,
    GRAPH_GRID_LINES:77,
    GRAPH_MINOR_GRID_LINES:78,
    GRAPH_OUTLINES:79,
    GRAPH_OUTLINES_PERIMETER:80,
    GRAPH_OUTLINES_UNFILLED:81,
    GRAPH_OUTLINES_NODE:82,
    GRAPH_BORDER_LINES:83,
    GRAPH_TITLE_TEXT:84,
    GRAPH_FOOTNOTE_TEXT:85,
    GRAPH_DATA_TEXT:86,
    GRAPH_KEY_TEXT:87,
    GRAPH_KEY_OUTLINE:88,
    GRAPH_KEY_FRAME_VALUE:89,
    GRAPH_LABEL_TEXT:90,
    GRAPH_LABEL2_TEXT:91,
    GRAPH_VALUE_TEXT:92,
    GRAPH_CALLOUT_LINE:93,
    GRAPH_KPI_RANGE_TEXT:94,
    GRAPH_KPI_VALUE_TEXT:95,
    GRAPH_BACKGROUND:96,
    GRAPH_WALLS:97,
    GRAPH_FLOOR:98,
    GRAPH_LEGEND_BACKGROUND:99,
    GRAPH_HEADER_BACKGROUND:100,
    GRAPH_FIT_LINE:101,
    GRAPH_FIT_LINE_2:102,
    GRAPH_PREDICTION_LINE:103,
    GRAPH_CONFIDENCE:104,
    GRAPH_CONFIDENCE_2:105,
    GRAPH_PREDICTION_LIMIT:106,
    GRAPH_ERROR:107,
    GRAPH_BOX_MEDIAN:108,
    GRAPH_BOX_MEAN:109,
    GRAPH_BOX_WHISKER:110,
    GRAPH_ANNO_LINE:111,
    GRAPH_ANNO_TEXT:112,
    GRAPH_ANNO_SHAPE:113,
    GRAPH_SELECTION:114,
    GRAPH_FOCUS:115,
    GRAPH_FOCUS_BACKGROUND:116,
    GRAPH_MISSING:117,
    GRAPH_CONTROL_LIMITS:118,
    GRAPH_RUN_TEST:119,
    GRAPH_STARS:120,
    GRAPH_CLIPPING:121,
    GRAPH_RANGE_FILL:122,
    GRAPH_DROP_SHADOW:123,
    GRAPH_BOX:124,
    GRAPH_HISTOGRAM:125,
    GRAPH_BAR:126,
    GRAPH_PIE:127,
    GRAPH_INSET_PIE:128,
    GRAPH_BUBBLE:129,
    GRAPH_SCATTER:130,
    GRAPH_HIGHLOW:131,
    GRAPH_HEATMAP:132,
    GRAPH_ICICLE:133,
    GRAPH_WATERFALL:134,
    GRAPH_SCHEDULE:135,
    GRAPH_TIMESERIES:136,
    GRAPH_SERIES:137,
    GRAPH_LINECHART:138,
    GRAPH_BAND:139,
    GRAPH_DECISIONTREE:140,
    GRAPH_LINEAGE:141,
    GRAPH_NETWORK:142,
    GRAPH_PROCESSFLOW:143,
    GRAPH_SANKEY:144,
    GRAPH_ELLIPSE:145,
    GRAPH_POLYGON:146,
    GRAPH_CONNECT_LINE:147,
    GRAPH_UNICODE_TEXT:148,
    GRAPH_OVERFLOW:149,
    GRAPH_UNDERFLOW:150,
    GRAPH_OUT_OF_RANGE:151,
    GRAPH_DATA_STYLE_INITIAL:152,
    GRAPH_DATA_STYLE_FINAL:153,
    GRAPH_DATA_STYLE_OTHER:154,
    GRAPH_ROW_COLUMN_AXIS_CELL_FILL:155,
    GRAPH_TIP_TEXT:156,
    GRAPH_TIP_FILL:157,
    GRAPH_MILESTONE:158,
    GRAPH_WEEKEND:159,
    GRAPH_CONTOUR:160,
    GRAPH_BLOCK:161,
    GRAPH_ALT_BLOCK:162,
    GRAPH_BLOCK_HEADER:163,
    GRAPH_CUT_LINE:164,
    GRAPH_TABLE_GRIDLINES:165,
    GRAPH_TABLE_HEADER_FILL:166,
    GRAPH_TABLE_HEADER_TEXT:167,
    GRAPH_TABLE_DATA_FILL:168,
    GRAPH_TABLE_DATA_TEXT:169,
    GRAPH_DIAGRAM_GRID_LINES:170,
    GRAPH_NODE_LINK_DIAGRAM:171,
    GRAPH_NODE:172,
    GRAPH_NODE_TITLE:173,
    GRAPH_NODE_LABEL:174,
    GRAPH_NODE_INPUT_LABEL:175,
    GRAPH_NODE_DETAILS:176,
    GRAPH_NODE_TEXT:177,
    GRAPH_NODE_LINK_LABEL:178,
    GRAPH_NODE_GROUP_OPEN:179,
    GRAPH_NODE_GROUP_CLOSED:180,
    GRAPH_NODE_GROUP_TITLE:181,
    GRAPH_NODE_WINDOW_GROUP_CONTENT_AREA:182,
    GRAPH_LINK:183,
    GRAPH_CROSSOVER_LINK:184,
    GRAPH_HIGHLIGHTED_LINK:185,
    GRAPH_HIGHLIGHTED_NODE:186,
    GRAPH_STATUS_BACKGROUND:187,
    GRAPH_STATUS_CLUSTERED:188,
    GRAPH_STATUS_COMPLETE:189,
    GRAPH_STATUS_ERROR:190,
    GRAPH_STATUS_IMPORTANT:191,
    GRAPH_STATUS_INCOMPLETE:192,
    GRAPH_STATUS_INCOMPLETE_IN_PROGRESS:193,
    GRAPH_STATUS_INFORMATION:194,
    GRAPH_STATUS_LOCKED:195,
    GRAPH_STATUS_MEDIUM_PRIORITY:196,
    GRAPH_STATUS_NEUTRAL:197,
    GRAPH_STATUS_PROGRESS:198,
    GRAPH_STATUS_SCHEDULED:199,
    GRAPH_STATUS_STOPPED:200,
    GRAPH_STATUS_STOPPING:201,
    GRAPH_STATUS_WARNING:202,
    GRAPH_ANIMATED_PROGRESS_INDICATOR:203,
    GRAPH_NOTE_YELLOW:204,
    GRAPH_NOTE_PINK:205,
    GRAPH_NOTE_BLUE:206,
    GRAPH_NOTE_TEXT:207,
    GRAPH_GROUP:208,
    GRAPH_GROUP_BACKGROUND:209,
    GRAPH_GROUP_TITLE:210,
    GRAPH_GROUP_NODE:211,
    GRAPH_LEVEL_GROUP_LABEL:212,
    GRAPH_LEVEL_GROUP_LINE:213,
    GRAPH_LEVEL_LABEL:214,
    GRAPH_SKIN:215,
    GRAPH_OVERVIEW_BACKGROUND:216,
    GRAPH_OVERVIEW_BORDER_LINES:217,
    GRAPH_OVERVIEW_VIEWPORT_BACKGROUND:218,
    GRAPH_OVERVIEW_VIEWPORT_BORDER_LINES:219,
    GRAPH_OVERVIEW_FILTER:220,
    GRAPH_OVERVIEW_AXIS:221,
    GRAPH_OVERVIEW_AXIS_FILTER:222,
    GRAPH_LINEAR_AXIS:223,
    GRAPH_LOG_AXIS:224,
    GRAPH_TIME_AXIS:225,
    GRAPH_DISCRETE_AXIS:226,
    GRAPH_CONTINUOUS_LEGEND:227,
    GRAPH_DISCRETE_LEGEND:228,
    GRAPH_SIZE_LEGEND:229,
    GRAPH_LAYOUT_OVERLAY:230,
    GRAPH_LAYOUT_LATTICE:231,
    GRAPH_LAYOUT_DATA_MATRIX:232,
    GRAPH_LAYOUT_DATA_PANEL:233,
    GRAPH_CELL_SEPARATOR_LINES:234,
    GRAPH_DATA_MATRIX_BORDER_LINES:235,
    GRAPH_ZOOM_SCROLLBAR_END_HANDLE:236,
    GRAPH_ZOOM_SCROLLBAR_THUMB:237,
    GRAPH:238,
    GRAPH_ANIMATION_CONTROL_PANEL:239,
    GRAPH_GAUGE_INDICATOR:240,
    GRAPH_OVERPLOTTING:241,
    GRAPH_OVERLAY_DATA_INSET:242,
    GRAPH_GEO_ROUTE_MAIN_PATH:243,
    GRAPH_GEO_ROUTE_CENTER_PATH:244,
    GRAPH_GEO_ROUTE_PATH_OUTER_PERIMETER:245,
    GRAPH_GEO_ROUTE_PATH_INNER_PERIMETER:246,
    GRAPH_GEO_ROUTE_PATH_SELECTION:247,
    GRAPH_GEO_ROUTE_PATH_HOVER:248,
    GRAPH_GEO_ROUTE_PATH_OUTER_PERIMETER_INVERSE:249,
    GRAPH_GEO_ROUTE_PATH_FOCUS:250,
    GRAPH_GEO_ROUTE_PATH_FOCUS_PERIMETER:251,
    GRAPH_GEO_ROUTE_POINT:252,
    GRAPH_GEO_ROUTE_POINT_LABEL:253,
    GRAPH_GEO_PIN:254,
    GRAPH_GEO_PIN_LABEL:255,
    GRAPH_GEO_PIN_ICON:256,
    GRAPH_GEO_SEARCH_PIN:257,
    GRAPH_GEO_CENTROID_POINT:258,
    GRAPH_GEO_AREA:259,
    GRAPH_GEO_AREA_OUTER_PERIMETER:260,
    GRAPH_GEO_AREA_INNER_PERIMETER:261,
    GRAPH_GEO_AREA_INNER_PERIMETER_THICK:262,
    GRAPH_GEO_AREA_OUTER_HOVER:263,
    GRAPH_GEO_AREA_OUTER_PERIMETER_INVERSE:264,
    GRAPH_GEO_AREA_SELECTION:265,
    GRAPH_GEO_AREA_OUTER_SELECTION:266,
    GRAPH_GEO_AREA_FOCUS:267,
    GRAPH_GEO_AREA_FOCUS_PERIMETER:268,
    GRAPH_GEO_REGION_EMPTY:269,
    GRAPH_ZONE_A:270,
    GRAPH_ZONE_B:271,
    GRAPH_ZONE_C:272,
    GRAPH_PHASE_BOX:273,
    GRAPH_SLIDER:274,
    GRAPH_MENU:275,
    GRAPH_THIN_LINE:276,
    GRAPH_DATA_STYLE_INCREASING:277,
    GRAPH_DATA_STYLE_DECREASING:278,
    GRAPH_BASEMAP:279,
    GRAPH_MAP_REGION_LAYER:280,
    REPORT:281,
    TITLESTYLE:282,
    PROMPTBAR:283,
    COMBOBOX:284,
    CHECKBOXLIST:285,
    SLIDER:286,
    BUTTONBAR:287,
    RADIOBUTTON:288,
    TEXTINPUT:289,
    HYPERLINK:290,
    HYPERLINKVISITED:291,
    DROPZONE:292,
    HOVER:293,
    SELECTED:294,
    TABLE:295,
    HEADER:296,
    DATA:297,
    BRUSH:298,
    ROW_HEADER:299,
    COLUMN_HEADER:300,
    ROW_HEADER_LABEL:301,
    COLUMN_HEADER_LABEL:302,
    MEASURE_HEADER:303,
    TOTALS:304,
    SUBTOTALS:305,
    TABLE_HEADER:306,
    TABLE_TOTALS:307,
    TABLE_TABLE:308,
    TABLE_DATA:309,
    TABLE_SELECTED:310,
    TABLE_BRUSH:311,
    CROSSTAB_TABLE:312,
    CROSSTAB_DATA:313,
    CROSSTAB_HEADER:314,
    CROSSTAB_TOTALS:315,
    CROSSTAB_SUBTOTALS:316,
    CROSSTAB_SELECTED:317,
    CROSSTAB_BRUSH:318,
    ZOOM_SCROLLBAR:319,
    STACK_NAVIGATION_CONTROL:320,
    STACK_CONTAINER:321,
    REPORT_ELEMENT_CONTAINER:322,
    REPORT_PAGE_PADDING:323,
    CONTAINER:324,
    SCROLLBAR:325,
    TABLE_SCROLLBAR:326,
    CROSSTAB_SCROLLBAR:327,
    TEXT_SCROLLBAR:328,
    TEXTSTYLE:329,
    H1:330,
    H2:331,
    H3:332,
    H4:333,
    H5:334,
    H6:335,
    INVALID:336,
    MATCHES_ALL:337
};
export default StyleElement;
